<template>
    <div class="mb-1">
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-icon
                    class="ml-1"
                    :color="show ? 'success' : 'grey'"
                    small
                    v-on="on"
                    @click="show=!show"
                >fa-clock</v-icon>
            </template>
            <span>{{'Time aggregation'|translate}}</span>
        </v-tooltip>
        <v-card v-if="show" class="mb-1">
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs2 class="pa-2">
                        <h4 class="pt-4">{{'Time Aggregation'|translate}}</h4>
                    </v-flex>
                    <v-flex xs2 class="pa-2">
                        <v-select :items="aggFreq" :label="'Frequency'|translate" v-model="agg.agg"></v-select>
                    </v-flex>
                    <v-flex xs2 class="pa-2">
                        <v-select :items="aggOpp" :label="'Operation'|translate" v-model="agg.agg_op"></v-select>
                    </v-flex>
                    <v-flex xs6 class="pa-2">
                        <v-layout row>
                            <v-switch color="success" v-if="agg.agg_op==='sum'" v-model="agg.divide_by_sf" :label="'Divide by sampling freq'|translate"></v-switch>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="$emit('apply')">{{'Apply'|translate}}</v-btn>
                            <v-btn color="primary" @click="$emit('clear')">{{'Clear'|translate}}</v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'TimeAggPanel',
    props: {
        agg: { type: Object, required: true },
    },
    data() {
        return {
            show: false,
            aggFreqOptions: [
                { textKey: 'hour', value: 'H' },
                { textKey: 'day', value: 'D' },
                { textKey: 'week', value: 'W' },
                { textKey: 'month start', value: 'MS' },
                { textKey: 'month end', value: 'M' },
                { textKey: 'year start', value: 'YS' },
                { textKey: 'year end', value: 'Y' },
            ],
            aggOpp: ['sum','mean','count','min','max'],
        }
    },
    computed: {
        aggFreq() {
            return this.aggFreqOptions.map((item) => ({
                text: this.$options.filters.translate(item.textKey),
                value: item.value,
            }))
        },
    },
}
</script>
